import { gql } from '@apollo/client'

export const contactSales = gql`
  query contactSales(
    $email: String
    $message: String
    $name: String
    $phone: String
    $unitsToBuy: BigFloat
  ) {
    contactSales(
      email: $email
      message: $message
      phone: $phone
      name: $name
      unitsToBuy: $unitsToBuy
    )
  }
`

export const emailToSales = gql`
  mutation SendEmailToSaleAbcForm(
    $companyName: String!
    $electricityAgreement: String
    $email: String!
    $expandable: Boolean
    $experiencedMiner: Boolean
    $facilityLocation: String
    $facilityName: String
    $megawatts: BigFloat
    $phone: String
    $stage: String!
  ) {
    sendEmailToSaleAbcForm(
      input: {
        companyName: $companyName
        electricityAgreement: $electricityAgreement
        email: $email
        expandable: $expandable
        experiencedMiner: $experiencedMiner
        facilityLocation: $facilityLocation
        facilityName: $facilityName
        megawatts: $megawatts
        phone: $phone
        stage: $stage
      }
    ) {
      boolean
    }
  }
`

export const emailLeadSales = gql`
  mutation SendEmailLeadSales(
    $additionalNotes: String
    $companyName: String
    $currentMiningCapacity: String
    $desiredDeploymentTimeline: Int
    $email: String!
    $firstName: String!
    $lastName: String!
    $numberOfMachines: String
    $phone: String
    $promoName: String
  ) {
    sendgridEmailLeadSales(
      input: {
        additionalNotes: $additionalNotes
        companyName: $companyName
        currentMiningCapacity: $currentMiningCapacity
        desiredDeploymentTimeline: $desiredDeploymentTimeline
        email: $email
        firstName: $firstName
        lastName: $lastName
        numberOfMachines: $numberOfMachines
        phone: $phone
        promoName: $promoName
      }
    ) {
      boolean
    }
  }
`

export const createAndSubscribeContact = gql`
  mutation CreateAndSubscribeContact($email: String!) {
    createAndSubscribeContact(input: {email: $email}) {
      boolean
    }
  }
`
